import { AuthStatus, ReduxAction, UserData } from 'interfaces';

const USER_DATA = 'USER_DATA';
const setUserData = (payload: UserData | null): ReduxAction<UserData | null> => ({ type: USER_DATA, payload: payload });
export { USER_DATA, setUserData };

const AUTH_STATUS = 'AUTH_STATUS';
const setAuth = (payload: AuthStatus): ReduxAction<AuthStatus> => ({ type: AUTH_STATUS, payload: payload });
export { AUTH_STATUS, setAuth };